import { ControlValidator } from '../../models/control-validator.model';
import { ControlCustomErrorsModel } from '../control-errors/models/control-custom-errors.model';

export const FILE_SIZE_ERROR = (size: number): ControlCustomErrorsModel =>
  ControlValidator.validationErrors('imageSize', `Image size is too large. Maximum allowed size ${size}MB.`);
export const COMPANY_SEQ = 0;
export const NOTIFICATION_MESSAGES = {
  saved: 'Image saved',
  deleted: 'Image deleted',
  defaultError: 'An error has occurred',
};
